/** Impact-report territory rows use the team's numeric id as `assetId` on the wire. */
export const parseImpactReportTeamId = (assetId: string): number | undefined => {
    const teamId = Number(assetId);

    if (!Number.isInteger(teamId) || teamId <= 0) {
        return undefined;
    }

    return teamId;
};
